export const DEFAULT_SCOPE = 'default';
export const DEFAULT_REMOTE_TYPE = 'global';
